import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'impact-story',
		path: '/impact-stories/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/impactStory" */ './index'), {
			exportName: 'ImpactStory',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
